import { Component } from '@angular/core';
import { selectAppointmentServices, selectAppointmentServicesSum, selectStartedAtConfirm } from '@modules/booking/store/appointment';
import { Store } from '@ngrx/store';

@Component({
  selector: 'pub-appointment-list',
  templateUrl: './appointment-list.component.html',
  styleUrls: ['./appointment-list.component.scss'],
})
export class AppointmentListComponent {
  appointmentServices$ = this.store.select(selectAppointmentServices);
  startDate$ = this.store.select(selectStartedAtConfirm);
  appointmentServicesSum$ = this.store.select(selectAppointmentServicesSum);

  constructor(private store: Store) {}
}
